import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class IssueDateEarlierThanPreviousAdvanceError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.issue-date.earlier-than-previous-advance');
    }
}
